import {
  ORGANIZATION_ACTIONS,
  ORGANIZATION_CERTAIN_EMPLOYEE,
  ORGANIZATION_EMPLOYEES,
} from 'constants/endpointConstants';
import { EDITING_ENTITY_TYPES } from '../../utils/editCommon';

export const GET_STAFF = 'app/EditStaff/GET_STAFF';
export const UPDATE_STAFF_ACTION = 'app/EditStaff/UPDATE_STAFF_ACTION';
export const GET_STAFF_SUGGESTIONS_ACTION = 'app/EditStaff/GET_STAFF_SUGGESTIONS_ACTION';
export const ADD_STAFF_ACTION = 'app/EditStaff/ADD_STAFF_ACTION';
export const DELETE_STAFF_ACTION = 'app/EditStaff/DELETE_STAFF_ACTION';
export const GET_STAFF_PROFFESSIONS = 'app/EditStaff/GET_STAFF_PROFFESSIONS';

export const entityFields = {
  [EDITING_ENTITY_TYPES.ORGANIZATION]: {
    name: 'profile',
    employeeProfession: 'profession',
    email: 'work_email',
    phones: 'work_phones',
    entity: 'organization',
    workEmail: 'workEmail',
    eamil: 'email',
    workPhoneNumber: 'workPhones',
  },
};

export const ACCESS_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  UNAVAILABLE: 'unavailable',
};

export const endpoints = {
  ORG: {
    getStaffList: ORGANIZATION_EMPLOYEES,
    update: ORGANIZATION_CERTAIN_EMPLOYEE,
    actions: ORGANIZATION_ACTIONS,
  },
};
